import { useFeatureAccessSettings } from '../featureAccessSettings';

type UseViewerCanAccessLeaderManagement = () => boolean;
export const useViewerCanAccessLeaderManagement: UseViewerCanAccessLeaderManagement = () => {
  const featureAccessSettings = useFeatureAccessSettings();

  return !!featureAccessSettings?.viewerCanAccessLeaderManagement;
};
